import React, { useEffect, useState } from 'react';
import { FiLoader } from "react-icons/fi";
import { FaLinkSlash } from "react-icons/fa6";
import { toast } from 'react-hot-toast';
import full from './full_logo.png';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

const HelcimSubscription = () => {
  const { contId, cid, sid } = useParams();
  
  const [loading, setLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [companyId, setCompanyId] = useState(cid);
  const [successUrl, setSuccessUrl] = useState('');
  const [checkoutToken, setCheckoutToken] = useState(null);
  const [userName, setUserName] = useState('');
  const [address, setAddress] = useState([]);
  const [isPaid, setIsPaid] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  
  useEffect(() => {
    if (cid) {
      handleGetCompanyDetails();
      handleGetSubscriptionDetails();
    }
  }, [cid]);

  const handleGetCompanyDetails = async () => {
    try {
      const response = await axios.get(`${baseURL}/company/unauthenticated-get-company/${cid}`, config);
      
      if (response.data.status === 'success') {
        setCompanyName(response?.data?.data?.entity?.name);
        setCompanyLogo(response?.data?.data?.entity?.profile_photo_url);
        setAddress(response?.data?.data?.entity?.address_data);
        setCompanyId(response?.data?.data?.entity?.data?.company_id || cid);
      }
    } catch (error) {
      console.error("Error fetching subscription details:", error);
    }
  };

  const handleGetSubscriptionDetails = async () => {
    try {
      const response = await axios.get(`${baseURL}/helcim-subscription/get-subscription/${sid}`, config);
      if (response.data.status === 'success') {
        const subscriptionData = response?.data?.data || {};
        setSubscriptionDetails({
          name: subscriptionData.product_name || 'Subscription',
          plan: subscriptionData.product_name || 'Standard',
          amount: subscriptionData.price ? (subscriptionData.price).toFixed(2) : '0.00',
          frequency: subscriptionData.payment_frequency || 'Monthly',
          description: subscriptionData.description || '',
          helcim_subscription_id: subscriptionData.helcim_subscription_id,
          status: subscriptionData.status
        });
        setUserName(subscriptionData.customer?.name);
        setIsExpired(!subscriptionData.is_active);
        setIsPaid(subscriptionData.status === 'Active' || subscriptionData.status === 'active');
        handleGetCheckoutToken(subscriptionData.payment_method === 'card' ? 'cc' : 'ach'); 
      }
    } catch (error) {
      console.error("Error fetching subscription details:", error);
    }
  };

  const handleGetCheckoutToken = async (typee) => {
    try {
      const formdata = {
        contact_id: contId,
        subscription_id: sid,
        customer_data: null,
        currency: 'USD',
        type: typee || 'cc',
      }
      const response = await axios.post(`${baseURL}/helcim-subscription/get-checkout-token/${cid}`, formdata, config);
      if (response.data.status === 'success') {
        setCheckoutToken(response?.data?.data?.entity?.checkoutToken);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching checkout token:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleCreateCustomer = async (paymentData) => {
    try {
      const response = await axios.post(
        `${baseURL}/helcim-subscription/create-customer/${cid}/${contId}/${sid}/${paymentData}`, 
        {}, 
        config
      );
      console.log(response);
      if (response.data.status === 'success') {
        window.location.reload();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error creating customer:", error);
    }
  };

  useEffect(() => {
    const handleMessage = async (event) => {
      const helcimPayJsIdentifierKey = 'helcim-pay-js-' + checkoutToken;
      
      if (event.data.eventName === helcimPayJsIdentifierKey && event.data.eventStatus === 'SUCCESS') {
        try {
          const jsonData = JSON.parse(event.data.eventMessage);
          if (jsonData?.data?.data?.status === 'APPROVED') {
            handleCreateCustomer(jsonData?.data?.data?.customerCode);
          } else {
            toast.error('Failed to save card details');
          }
        } catch (error) {
          console.error("Error processing payment message:", error);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [checkoutToken, companyId]);

  if (loading) {
    return (
      <div className="w-full h-[100vh] items-center justify-between flex flex-col">
        <FiLoader size={50} className="animate-spin mt-[47vh]" />
        <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
          <span className="text-[#535355]"> Powered by</span>
          <div
            className='flex items-center ml-1 cursor-pointer'
            onClick={() => window.open('https://www.salescaptain.com')}
          >
            <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className="h-[18px]" alt="" />
            <span className="font-semibold ml-1">{localStorage.getItem('h_name') ?? 'SalesCaptain'}</span>
          </div>
        </div>
      </div>
    );
  }

  if (isExpired === true) {
    return (
      <div className="w-full h-full items-center justify-center flex flex-col">
        <FaLinkSlash className="text-[80px] mb-[20px]" />
        <span className="text-[30px] medium">Link Expired</span>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center">
      <div className="flex gap-3 items-center text-[#1a1a1ab3] medium text-[15px]">
        {companyLogo && (
          <span className="text-[#1a1a1ab3] medium text-[15px] bg-white p-1 w-[60px] h-[60px] rounded-md object-fill">
            <img className="w-full h-full" src={companyLogo} alt="" />
          </span>
        )}
        <div className="flex flex-col gap-1">
          <span className="text-[#3975cb] medium text-[18px] tracking-wide">{companyName}</span>
          <span className="regular text-[10px] tracking-wide">
            {address?.street_address} {address?.apartment_or_suite} {address?.city} {address?.zip}
          </span>
        </div>
      </div>
      
      <div className="space-y-2 shadow-xl flex flex-col rounded-[25px] p-3 px-7 w-[380px] border-[1px] border-[#E2E8F0] mt-5">
        <div className="flex items-center justify-between border-b">
          <div className="text-gray-500 medium text-[16px] py-2">
            Subscriber:
          </div>
          <div className="text-gray-500 medium text-[16px] py-2">
            {userName}
          </div>
        </div>
        
        {/* <div className="text-gray-400 medium self-center text-[15px] pr-2 w-fit break-words">
          Subscribe to {subscriptionDetails?.name || 'Subscription'}
        </div> */}
        
        <div className="flex items-center justify-between mt-3">
          <div className="text-gray-500 regular text-[14px]">
            Subscription Plan
          </div>
          <div className="text-gray-500 medium text-[14px]">
            {subscriptionDetails?.plan || 'Standard'}
          </div>
        </div>
        
        {subscriptionDetails?.frequency && (
          <div className="flex items-center justify-between mt-3">
            <div className="text-gray-500 regular text-[14px]">
              Billing Frequency
            </div>
            <div className="text-gray-500 medium text-[14px]">
              {subscriptionDetails.frequency}
            </div>
          </div>
        )}

        {subscriptionDetails?.status && (
          <div className="flex items-center justify-between mt-3">
            <div className="text-gray-500 regular text-[14px]">
              Status
            </div>
            <div className="text-gray-500 medium text-[14px] capitalize">
              {subscriptionDetails.status}
            </div>
          </div>
        )}
        
        <div className="flex items-center !mt-4 justify-between border-t">
          <div className="text-[#1a1a1a] w-1/2 sm:w-full medium text-[16px] pt-2">
            Amount:
          </div>
          <div className="text-[#1a1a1a] medium text-[18px]">
            ${subscriptionDetails?.amount || '0.00'}
          </div>
        </div>
        
        {isPaid ? (
          <a className='bg-[#b4ee9f] text-[#2B9F00] font-semibold p-3 text-center text-[16px] w-[100%] rounded-2xl'>
            Subscribed
          </a>
        ) : (
          <a
            href={`javascript: appendHelcimPayIframe('${checkoutToken}', false)`}
            className='bg-blue-500 text-white font-semibold p-3 text-center w-[100%] rounded-2xl'
            onClick={() => setPaymentLoading(true)}
          >
            {paymentLoading ? 'Processing' : 'Subscribe Now'}
          </a>
        )}
      </div>
      
      <div className='flex justify-center gap-2 items-center mt-5'>
        <span className="text-gray-400 regular self-center mt-1 text-[10px]">Powered by </span>
        <img className="h-[14px]" src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} alt="" />
        <span className="text-sm capitalize">{localStorage.getItem('h_name') ?? 'SalesCaptain'}</span>
      </div>
      <script async defer type="text/javascript" src="https://secure.helcim.app/helcim-pay/services/start.js"></script>
    </div>
  );
};

export default HelcimSubscription;
